import React from "react";
import { useAccountStore } from "../store";
import { useLocation, Navigate } from "react-router-dom";

// export default function ProtectedRoute({children}) {
//   const { me } = useAccountStore();
//   const navigate = useNavigate();
//   const location = useLocation();

//   if (!me) {
//     return navigate("/login", {
//       state: {
//         from: location,
//       },
//     });
//   }

//   return children;
// }

const ProtectedRoute = ({children}) => {
  const { me } = useAccountStore();
  const location = useLocation();

  if (!me) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;